import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { b as vMinLength, a as vString, a1 as vUndefOr, Q as vBoolean, _ as vNull, J as vNumber, W as vArrayOf, R as vTrue, a2 as vFunction } from './validation-02b8d01d.js';
import { r as runValidation } from './form-4ba95191.js';
import { w as waitNextRender, r as resolveNextRender } from './browser-202fc7f4.js';
import { c as currentLocale } from './i18n-939e2dee.js';

const dsInputCheckboxCss = "ds-input-checkbox{display:block}ds-input-checkbox label{display:inline-block;position:relative;padding-left:1.9rem;cursor:pointer;-webkit-user-select:none;-ms-user-select:none;user-select:none;font-size:0.88888889rem;line-height:1.56rem;opacity:0.8;height:1.62rem}ds-input-checkbox label input{position:absolute;cursor:pointer;left:0;top:0.25rem;opacity:0}ds-input-checkbox[is-toggle] input+span{position:absolute;top:0;bottom:0;left:0;right:0;border-radius:200px;border:none;background-color:var(--grey-600)}ds-input-checkbox[is-toggle] input:checked+span{background:var(--primary)}ds-input-checkbox[is-toggle] input+span:before{content:\"\";display:inline-block;position:absolute;top:50%;left:4px;width:16px;height:16px;background:white;border-radius:50%;transform:translateY(-50%);transition:all 0.5s}ds-input-checkbox[is-toggle] input:checked+span:before{left:20px}ds-input-checkbox[is-toggle] .checkmark{width:42px !important;height:24px !important}ds-input-checkbox[is-toggle] .checkmark::after{display:none !important}ds-input-checkbox[is-toggle] .label{position:relative;left:1.25rem}ds-input-checkbox[is-toggle] .help-info,ds-input-checkbox[is-toggle] .help-error{padding:0 !important}ds-input-checkbox[is-toggle] .help-error{left:3rem !important}ds-input-checkbox[label=''] input{min-width:2.5rem}ds-input-checkbox[label=''] label{padding-left:1.2rem}ds-input-checkbox .help-info,ds-input-checkbox .help-error{position:relative;padding:0.45rem 0 0;line-height:1;left:2rem;font-size:0.79012346rem;line-height:1.3rem;color:var(--grey-900)}ds-input-checkbox .checkmark{position:absolute;top:0.25rem;left:0;height:1.12rem;width:1.1rem;border:1px solid var(--grey-800);border-radius:calc(var(--radius) / 2);background-color:var(--white);pointer-events:none}ds-input-checkbox .checkmark::after{content:'';position:absolute;display:none;left:40%;top:10%;width:0.2rem;height:0.6rem;border:solid white;border-width:0 2px 2px 0;transform:rotate(45deg)}ds-input-checkbox.error label,ds-input-checkbox.error .help-error{color:var(--red-500) !important}ds-input-checkbox.error label{opacity:1}ds-input-checkbox.error .checkmark{border-color:var(--red-500)}ds-input-checkbox:hover label{opacity:1}ds-input-checkbox[is-checked] .checkmark{background-color:var(--primary);border:0}ds-input-checkbox[is-checked] .checkmark::after{display:block}ds-input-checkbox[is-checked] label{opacity:1}ds-input-checkbox[is-readonly] *,ds-input-checkbox[is-disabled] *{cursor:not-allowed}ds-input-checkbox[is-readonly][is-toggle] input+span,ds-input-checkbox[is-disabled][is-toggle] input+span{border:3px solid var(--grey-600);background-color:initial}ds-input-checkbox[is-readonly][is-toggle] input+span:before,ds-input-checkbox[is-disabled][is-toggle] input+span:before{background:var(--grey-600)}ds-input-checkbox[is-readonly] .checkmark,ds-input-checkbox[is-disabled] .checkmark{background-color:var(--grey-600);border:none}ds-input-checkbox[is-readonly] label,ds-input-checkbox[is-disabled] label{opacity:0.7}ds-input-checkbox[is-readonly][is-checked] .checkmark{background-color:var(--primary);opacity:0.5}";

const DsInputCheckbox = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dsInput = createEvent(this, "dsInput", 7);
    this.nextRenderPromises = [];
    this.displayError = false;
    this.validationError = undefined;
    this.injectedError = undefined;
    this.propError = {};
    this.currentLocale = currentLocale();
    this.name = undefined;
    this.label = '';
    this.helperText = undefined;
    this.isToggle = false;
    this.isDisabled = false;
    this.isReadonly = false;
    this.isWithoutStyling = false;
    this.value = null;
    this.checkedValue = true;
    this.validate = undefined;
    this.isChecked = undefined;
  }
  // istanbul ignore next
  updateLocale() {
    this.currentLocale = currentLocale();
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vMinLength(1)))
      return;
  }
  watchLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'label', 'string', vString))
      return;
  }
  watchHelperText() {
    /* istanbul ignore if */
    if (!propCheck(this, 'helperText', 'string', vUndefOr(vString)))
      return;
  }
  watchIsToggle() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isToggle', 'boolean', vBoolean))
      return;
  }
  async watchIsDisabled() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDisabled', 'boolean', vBoolean))
      return;
    if (this.isDisabled) {
      this.uncheckIfChecked();
    }
    await waitNextRender(this);
    runValidation(this);
  }
  async watchIsReadonly() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isReadonly', 'boolean', vBoolean))
      return;
    await waitNextRender(this);
    runValidation(this);
  }
  watchIsWithoutStyling() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isWithoutStyling', 'boolean', vBoolean))
      return;
  }
  watchValue() {
    /* istanbul ignore if */
    if (!propCheck(this, 'value', 'null | string | number | boolean | Array<string | number>', v => vNull(v) && vString(v) && vNumber(v) && vBoolean(v) && vArrayOf(v => vString(v) && vNumber(v))(v)))
      return;
    this.setCheckedFromValue();
    this.injectedError = undefined;
    runValidation(this);
  }
  watchCheckedValue(_, oldCheckedValue) {
    /* istanbul ignore if */
    if (!propCheck(this, 'checkedValue', 'string | number | true', v => vString(v) && vNumber(v) && vTrue(v)))
      return;
    if (typeof oldCheckedValue !== 'undefined') {
      /* istanbul ignore else */
      if (Array.isArray(this.value)) {
        let idx = this.value.findIndex(v => v === oldCheckedValue);
        /* istanbul ignore else */
        if (idx !== -1 && this.checkedValue !== true) {
          let newValue = this.value;
          newValue[idx] = this.checkedValue;
          this.dsInput.emit(newValue);
        }
      }
      else if (this.value === oldCheckedValue) {
        this.dsInput.emit(this.checkedValue);
      }
    }
  }
  watchValidate() {
    /* istanbul ignore if */
    if (!propCheck(this, 'validate', '(value: any) => string | undefined', vUndefOr(vFunction)))
      return;
    runValidation(this);
  }
  async injectError(error) {
    this.injectedError = error;
    runValidation(this);
    this.displayError = true;
  }
  async hideError() {
    this.injectedError = undefined;
    runValidation(this);
    this.displayError = false;
  }
  setCheckedFromValue() {
    if (Array.isArray(this.value)) {
      this.isChecked = this.value.findIndex(v => v === this.checkedValue) !== -1;
    }
    else {
      this.isChecked = !!this.value;
    }
  }
  emitDsInput() {
    this.isChecked = this.inputElement.checked;
    if (Array.isArray(this.value)) {
      let newValue = [...this.value];
      if (this.inputElement.checked) {
        /* istanbul ignore else */
        if (newValue.findIndex(v => v === this.checkedValue) === -1 && this.checkedValue !== true) {
          newValue.push(this.checkedValue);
        }
      }
      else {
        let idx = newValue.findIndex(v => v === this.checkedValue);
        /* istanbul ignore else */
        if (idx !== -1)
          newValue.splice(idx, 1);
      }
      this.dsInput.emit(newValue);
    }
    else {
      this.dsInput.emit(this.inputElement.checked ? this.checkedValue : false);
    }
  }
  uncheckIfChecked() {
    if (this.isChecked) {
      if (Array.isArray(this.value)) {
        const newValue = [...this.value];
        newValue.splice(newValue.findIndex(v => v === this.checkedValue), 1);
        this.dsInput.emit(newValue);
      }
      else {
        this.dsInput.emit(null);
      }
    }
  }
  connectedCallback() {
    runWatchers(this);
    this.updateLocale();
  }
  componentDidLoad() {
    if (this.inputElement)
      this.dsForm = this.inputElement.closest('ds-form');
    this.setCheckedFromValue();
    runValidation(this);
  }
  componentDidRender() {
    resolveNextRender(this);
  }
  disconnectedCallback() {
    if (this.dsForm)
      this.dsForm.checkValidity();
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    const error = this.displayError && (this.injectedError || this.validationError);
    return (h(Host, { class: { error: !!error }, "is-checked": this.isChecked }, h("label", null, h("input", { ref: el => this.inputElement = el, name: this.name, id: `ds-input-${this.name}`, type: "checkbox", disabled: this.isDisabled || this.isReadonly, checked: this.isChecked, onInput: () => { this.displayError = true; this.emitDsInput(); }, onBlur: () => this.displayError = true, onInvalid: () => this.displayError = true }), h("span", { class: 'checkmark' }), h("span", { class: "label" }, this.label)), h("span", { class: "help-info" }, this.helperText, h("slot", { name: "helperText" })), error && h("div", { class: "help-error" }, error)));
  }
  static get watchers() { return {
    "name": ["watchName"],
    "label": ["watchLabel"],
    "helperText": ["watchHelperText"],
    "isToggle": ["watchIsToggle"],
    "isDisabled": ["watchIsDisabled"],
    "isReadonly": ["watchIsReadonly"],
    "isWithoutStyling": ["watchIsWithoutStyling"],
    "value": ["watchValue"],
    "checkedValue": ["watchCheckedValue"],
    "validate": ["watchValidate"]
  }; }
};
DsInputCheckbox.style = dsInputCheckboxCss;

export { DsInputCheckbox as ds_input_checkbox };
